<template>
    <z-basePage :title="'虚拟币设置'">
        <div class="tab-title">
            <div class="tab-btn" :class="{active:activeIndex==0}" @click="changeTab(0)">虚拟币类型</div>
            <div class="tab-btn" :class="{active:activeIndex==1}" @click="changeTab(1)">汇率设置</div> 
        </div>

        <div class="tab">
            <div class="tab-main" v-show="activeIndex == 0">
                <!-- <div class="btns-top">
                    <div class="back-btn blue" :class="{disabled:currencyList.length>=2}" @click="link(0)">创建</div>
                </div> -->
                <div class="back-list page">
                    <div class="list-head">
                        <div>虚拟币名称</div>
                        <div>虚拟币描述</div>
                        <!-- <div>操作</div> -->
                    </div>
                    <z-scrollDiv class="main">
                        <div class="list-item"  v-for="item in currencyList" :key="item.id">
                            <div>{{ item.currency_name }}</div>
                            <div class="overhide">{{ item.description }}</div>
                            <!-- <div>
                                <span class="blue" @click="link(item.id)">编辑</span>
                            </div> -->
                        </div>
                    </z-scrollDiv>
                </div>
            </div>

            <rate class="tab-main" v-show="activeIndex == 1"></rate>
        </div>
        
    </z-basePage>
</template>

<script>
    import rate from 'src/views/backEndStage/setting/rate.vue'

    import { mapState } from "vuex";

    export default {
        components:{
            rate,
        },

        computed:{
            ...mapState(["currencyList"]),
            activeIndex(){
                return this.$route.query.tab || 0;
            },
        },
        
        created(){
            this.$func.getCurrencyList(true);
        },

        methods:{
            link(id){
                let str = this.$crypto.encrypt(id);
                this.$router.push({
                    name:'back-setting-addcurrency',
                    params:{
                        id:str
                    }
                })
            },
            changeTab(val){
                this.$router.replace({
                    name:'back-setting-currency',
                    query:{
                        tab:val
                    },
                })
            }
        }

    }
</script>

<style lang="less" scoped>
    .tab{
        height:calc(~"100% - 40px");
        .tab-main{
            height:100%;
            padding-top: 0.1px;
        }
    }

    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 20%;
        }
        >div:nth-of-type(2){
            width: 40%;
        }
        >div:nth-of-type(3){
            width: 20%;
        }
        >div:nth-of-type(4){
            width: 10%;
            padding-left: 10%;
            span{
                cursor: pointer;
                display: inline-block;
                &+span{
                    margin-left:10px;
                }
            }
        }
    }

</style>





// WEBPACK FOOTER //
// page-currency.vue?0ada5638